
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import Table from './Table'
import api from '~/api/' // server
import SearchSelect from '~/components/Common/UI/Search/SearchSelect'

export default {
    name: 'Features',
    components: { SearchSelect, Table },
    data() {
        return {
            features: Array,
            searchType: 'date'
        }
    },
    computed: {
        ...mapGetters('search', ['getSearch']),
    },

    watch: {
        getSearch() {
            this.getFeatues()
        },
    },

    mounted() {
        /* 
            220314 meej
            당일 데이터 없을경우 최근 입력 데이터 보여주기
        */
        this.getFeatuesInit()
    },

    methods: {
        async getFeatues() {
            this.features = null
            const params = {
                menuType: 'MENU_STOCK_FEATURED',
                ...this.getSearch,
            }
            this.features = (await api.getFeatues(params)).data
            const result = []
            const group = this.groupBy(this.features.items, 'pid')
            for (const key of Object.keys(group)) {
                result.push(group[key])
            }
            this.features.items = result
        },

        onSearchTypeChange(type) {
            this.searchType = type === '종목' ? 'stock' : 'date'
        },

        /* 
            220314 meej
            당일 데이터 없을경우 최근 입력 데이터 보여주기
        */
        async getFeatuesInit() {
            this.features = null
            const params = {
                menuType: 'MENU_STOCK_FEATURED',
                ...this.getSearch,
            }

            this.features = (await api.getFeatues(params)).data
           
            let count = 0
            while(this.features.items.length < 1){
                count++
                params.startDate = dayjs(new Date()).subtract(count, 'days').format('YYYYMMDD')
                this.features = (await api.getFeatues(params)).data
            }

            const result = []
            const group = this.groupBy(this.features.items, 'pid')
            for (const key of Object.keys(group)) {
                result.push(group[key])
            }
            this.features.items = result
        },

        groupBy(arr, key) {
            const result = arr.reduce(function (acc, el) {
                const group = el[key]

                if (acc[group] === undefined) {
                    acc[group] = []
                }
                acc[group].push(el)
                return acc
            }, {})
            return result
        },
    },
}
